export const UAE_REGION_CONSTANTS = {
  HMS: 'hms',
  RM_DISABLED_TEXT: 'The RM Call is disabled temporarily in UAE Region.',
  RM_DISABLED_TOGGLE_TEXT: 'The Toggle RM Call is disabled temporarily in UAE Region',
};

export const PRE_CLASS_SCREEN_MAX_TIME = 300; // 5 minutes in seconds
